module.exports = __webpack_public_path__ + "media/mypage/images/top/events_textbook_sp-4c5f2bb0e3dd28d9735ec7bf7a409dcf.png";